import React, { useEffect, useState } from "react"
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap"
import { FaSave } from "react-icons/fa"
import { MdCancel } from "react-icons/md"
import { fetchData } from "utils/Common_api_functions"

const ProductModal = ({
  open,
  close,
  formData,
  setFormData,
  onSubmit,
  mode,
}) => {
  const isView = mode === "view"
  const [errors, setErrors] = useState({})

  const [loading, setLoading] = useState(false)
  const [departments, setDepartments] = useState([])
  const [category, setcategory] = useState([])
  const [ClassName, setClassName] = useState([])
  const [stones, setStones] = useState([])
  const [ProgramBuilds, setProgramBuilds] = useState([])
  const [brands, setBrands] = useState([])

  useEffect(() => {
    fetchValues()
  }, [])

  // Fetch All related Values
  async function fetchValues() {
    const APIdata = await fetchData(setLoading, "department")
    if (APIdata?.success) {
      setDepartments(APIdata?.data)
    }

    const APIdata2 = await fetchData(setLoading, "category")
    if (APIdata?.success) {
      setcategory(APIdata2?.data)
    }

    const APIdata3 = await fetchData(setLoading, "class")
    if (APIdata?.success) {
      setClassName(APIdata3?.data)
    }

    const APIdata4 = await fetchData(setLoading, "program/build")
    if (APIdata?.success) {
      setProgramBuilds(APIdata4?.data)
    }

    const APIdata5 = await fetchData(setLoading, "stone")
    if (APIdata?.success) {
      setStones(APIdata5?.data)
    }

    const APIdata6 = await fetchData(setLoading, "brand")
    if (APIdata?.success) {
      setBrands(APIdata6?.data)
    }
  }

  const handleChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  const validate = () => {
    let newErrors = {}

    if (!formData?.departmentId) newErrors.departmentId = "Department is required"
    if (!formData?.categoryId) newErrors.categoryId = "Category is required"
    if (!formData?.productName) newErrors.productName = "Product name is required"
    if (!formData?.skuNumber) newErrors.skuNumber = "SKU number is required"

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = () => {
    if (isView) return close()

    if (validate()) {
      onSubmit()
    }
  }

  return (
    <Modal isOpen={open} toggle={close} size="lg" centered>
      <ModalHeader toggle={close}>
        {isView ? "View" : formData?.id ? "Edit" : "Add"} Product
      </ModalHeader>

      <ModalBody>
        <Row>
          {/* SKU */}
          <Col md="6" className="mb-3">
            <Label>SKU No <span className="text-danger">*</span></Label>
            <Input
              name="skuNumber"
              value={formData?.skuNumber || ""}
              onChange={handleChange}
              disabled={isView}
            />
            {errors.skuNumber && (
              <small className="text-danger">{errors.skuNumber}</small>
            )}
          </Col>

          {/* Product Name */}
          <Col md="6" className="mb-3">
            <Label>Product Name <span className="text-danger">*</span></Label>
            <Input
              name="productName"
              value={formData?.productName || ""}
              onChange={handleChange}
              disabled={isView}
            />
            {errors.productName && (
              <small className="text-danger">{errors.productName}</small>
            )}
          </Col>

          {/* Department */}
          <Col md="6">
            <Label>Department <span className="text-danger">*</span></Label>
            <Input
              type="select"
              name="departmentId"
              value={formData?.departmentId || ""}
              onChange={handleChange}
              disabled={isView}
            >
              <option value="">Select Department</option>
              {departments?.map(item => (
                <option key={item?.id} value={item?.id}>
                  {item?.departmentName}
                </option>
              ))}
            </Input>
            {errors.departmentId && (
              <small className="text-danger">{errors.departmentId}</small>
            )}
          </Col>

          {/* Category */}
          <Col md="6">
            <Label>Category <span className="text-danger">*</span></Label>
            <Input
              type="select"
              name="categoryId"
              value={formData?.categoryId || ""}
              onChange={handleChange}
              disabled={isView}
            >
              <option value="">Select Category</option>
              {category?.map(item => (
                <option key={item?.id} value={item?.id}>
                  {item?.categoryName}
                </option>
              ))}
            </Input>
            {errors.categoryId && (
              <small className="text-danger">{errors.categoryId}</small>
            )}
          </Col>

          {/* Class */}
          <Col md="6" className="mt-3">
            <Label>Class</Label>
            <Input
              type="select"
              name="classId"
              value={formData?.classId || ""}
              onChange={handleChange}
              disabled={isView}
            >
              <option value="">Select Class</option>
              {ClassName?.map(item => (
                <option key={item?.id} value={item?.id}>
                  {item?.className}
                </option>
              ))}
            </Input>
          </Col>

          {/* Program Build */}
          <Col md="6" className="mt-3">
            <Label>Program Build</Label>
            <Input
              type="select"
              name="programBuildId"
              value={formData?.programBuildId || ""}
              onChange={handleChange}
              disabled={isView}
            >
              <option value="">Select Program Build</option>
              {ProgramBuilds?.map(item => (
                <option key={item?.id} value={item?.id}>
                  {item?.programBuildName}
                </option>
              ))}
            </Input>
          </Col>

          {/* Stone Type */}
          <Col md="6" className="mt-3">
            <Label>Stone Type</Label>
            <Input
              type="select"
              name="stoneId"
              value={formData?.stoneId || ""}
              onChange={handleChange}
              disabled={isView}
            >
              <option value="">Select Stone Type</option>
              {stones?.map(item => (
                <option key={item?.id} value={item?.id}>
                  {item?.stoneName}
                </option>
              ))}
            </Input>
          </Col>

          <Col md="6" className="mt-3">
            <Label>Brand</Label>
            <Input
              type="select"
              name="brandId"
              value={formData?.brandId || ""}
              onChange={handleChange}
              disabled={isView}
            >
              <option value="">Select Brand</option>
              {brands?.map(item => (
                <option key={item?.id} value={item?.id}>
                  {item?.brandName}
                </option>
              ))}
            </Input>
          </Col>

          {/* Product Name */}
          <Col md="6" className="mt-3">
            <Label>Component Type</Label>
            <Input
              name="componentType"
              value={formData?.componentType || ""}
              onChange={handleChange}
              disabled={isView}
            />
          </Col>

          {/* Product Name */}
          <Col md="6" className="mt-3">
            <Label>Component Code</Label>
            <Input
              name="componentCode"
              value={formData?.componentCode || ""}
              onChange={handleChange}
              disabled={isView}
            />
          </Col>
        </Row>
      </ModalBody>

      <ModalFooter>
        {!isView && (
          <Button className="btn-blue" onClick={handleSubmit}>
            <FaSave className="me-1" />
            Save
          </Button>
        )}
        <Button color="secondary" onClick={close}>
          <MdCancel className="me-1" />
          {isView ? "Close" : "Cancel"}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default ProductModal
